/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DailyCarbonEmissionEstimate
 */
export interface DailyCarbonEmissionEstimate {
    /**
     *
     * @type {Date}
     * @memberof DailyCarbonEmissionEstimate
     */
    date?: Date;
    /**
     *
     * @type {number}
     * @memberof DailyCarbonEmissionEstimate
     */
    emissionKg?: number;
    /**
     *
     * @type {number}
     * @memberof DailyCarbonEmissionEstimate
     */
    scope1EmissionKg?: number;
    /**
     *
     * @type {number}
     * @memberof DailyCarbonEmissionEstimate
     */
    scope2EmissionKg?: number;
    /**
     *
     * @type {number}
     * @memberof DailyCarbonEmissionEstimate
     */
    scope3EmissionKg?: number;
}

/**
 * Check if a given object implements the DailyCarbonEmissionEstimate interface.
 */
export function instanceOfDailyCarbonEmissionEstimate(
    value: object,
): value is DailyCarbonEmissionEstimate {
    return true;
}

export function DailyCarbonEmissionEstimateFromJSON(
    json: any,
): DailyCarbonEmissionEstimate {
    return DailyCarbonEmissionEstimateFromJSONTyped(json, false);
}

export function DailyCarbonEmissionEstimateFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DailyCarbonEmissionEstimate {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        emissionKg: json["emissionKg"] == null ? undefined : json["emissionKg"],
        scope1EmissionKg:
            json["scope1EmissionKg"] == null
                ? undefined
                : json["scope1EmissionKg"],
        scope2EmissionKg:
            json["scope2EmissionKg"] == null
                ? undefined
                : json["scope2EmissionKg"],
        scope3EmissionKg:
            json["scope3EmissionKg"] == null
                ? undefined
                : json["scope3EmissionKg"],
    };
}

export function DailyCarbonEmissionEstimateToJSON(
    value?: DailyCarbonEmissionEstimate | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        emissionKg: value["emissionKg"],
        scope1EmissionKg: value["scope1EmissionKg"],
        scope2EmissionKg: value["scope2EmissionKg"],
        scope3EmissionKg: value["scope3EmissionKg"],
    };
}
